import * as styles from "./index.module.scss";
import { IconWrapProps } from "../types";
import React from "react";

const IconWrap = ({ children, size = "" }: IconWrapProps) => {
  const style = {
    fontSize: size,
  };

  return (
    <span className={styles.icon} style={style}>
      {children}
    </span>
  );
};

export default IconWrap;
